import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const popularCategories = categories.slice(0, 6);

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between gap-10 mb-12">
            <div className="md:max-w-xs">
              <Link
                to="/"
                className="font-heading text-xl font-semibold text-background-50 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                SugargooSpreadsheet<span className="text-primary-400">.link</span>
              </Link>
              <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
                An independent community-driven resource for Sugargoo shoppers. Not affiliated with Sugargoo or any brands mentioned.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Popular Categories</h4>
                <div className="flex flex-col gap-2.5">
                  {popularCategories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Quick Links</h4>
                <div className="flex flex-col gap-2.5">
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Home</Link>
                  <Link to="/guide/what-is-sugargoo-spreadsheet" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Guides</Link>
                  <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Main Site</a>
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Legal</h4>
                <div className="flex flex-col gap-2.5">
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Disclaimer</Link>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Privacy Policy</Link>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Terms</Link>
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">Community</h4>
                <div className="flex flex-col gap-2.5">
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Twitter</a>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Reddit</a>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">Discord</a>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500 whitespace-nowrap">
              &copy; 2026 SugargooSpreadsheet.link — All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                Sugargoo Spreadsheet
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-primary-500 text-background-50 rounded-full text-xs font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                Buy It Now
                <i className="ri-arrow-right-up-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}